export default "__VITE_ASSET__CzA24ubc__"